module.exports = __webpack_public_path__ + "img/sorry.3842609e.webp";